import type { ISessionUser } from '@frontend/configureStore';
import { nonNullable } from '@common/utils/nonNullableTypeUtils';
import { fetchJson } from '@frontend/store/fetch';

export async function fetchSession(signal: AbortSignal) {
    const url = '/api/session';
    const response = await fetchJson<ISessionUser>({ method: 'GET', signal, url });

    return nonNullable(response.json);
}
